import styled from 'styled-components';
import { brandColors } from 'styles/colors';
import { breakpoint, color, font } from 'styles/globals';
import { getIcon } from 'styles/icons';
import { type Theme, getColor } from 'styles/theme';

export const Wrapper = styled.div<{ theme: Theme }>`
  min-width: 0;
  border: 1px solid ${getColor('borderTertiary')};
  display: flex;
  position: relative;

  &.check-svg, &.checkmark {
    position: relative;

    &::before {
      position: absolute;
      ${getIcon('checkmark-full', { height: 24, width: 24 })}
      background-color: ${color.newsletterLine};
      top: -10px;
      left: -12px;
      z-index: 2;
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: -12px;
      left: -12px;
      z-index: 1;
      width: 24px;
      height: 24px;
      background-color: ${getColor('iconWhite')}; 
    }
  }

  @media (${breakpoint.mmMin}) {
    min-height: 68px;
  }

  @media (${breakpoint.lgMin}) {
    min-height: 74px;
  }
`;

export const TitleWrapper = styled.div<{ theme: Theme }>`
  flex: 1;
  display: flex;
  align-items: center;
  min-width: 0;
  font-family: ${font.graphikCond};
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0.5px;
  color: ${getColor('textPrimary')};
  background: ${brandColors.crypto.shadeBrandPrimary100};
  padding: 14px 16px;
  width: calc(100% - 64px);

  &.recently-unsubscribed {
    background: ${getColor('surfaceTertiary')};
  }

  @media (${breakpoint.lgMin}) {
    padding: 12px 16px;
    font-size: 20px;
    line-height: 24px;
  }
`;

export const Title = styled.p`
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SubscribeButton = styled.button<{ theme: Theme }>`
  padding: 0 16px;

  &:hover {
    .svg-path {
      fill: ${getColor('textLink')};
    } 
  }
`;
